/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * API Reference
 * OpenAPI spec version: 1.0
 */

/**
 * Validation failure code for the validation failure.
 */
export type PayoutValidationErrorCode = typeof PayoutValidationErrorCode[keyof typeof PayoutValidationErrorCode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PayoutValidationErrorCode = {
  UNIONPAY_INVALID_BANK_ACCOUNT: 'UNIONPAY_INVALID_BANK_ACCOUNT',
  UNIONPAY_AMOUNT_EXCEEDS_LIMIT: 'UNIONPAY_AMOUNT_EXCEEDS_LIMIT',
  UNIONPAY_INVALID_CURRENCY: 'UNIONPAY_INVALID_CURRENCY',
  UNIONPAY_AMOUNT_LESS_THAN_LIMIT: 'UNIONPAY_AMOUNT_LESS_THAN_LIMIT',
  UNIONPAY_INVALID_BANK_ACCOUNT_TYPE: 'UNIONPAY_INVALID_BANK_ACCOUNT_TYPE',
  UNIONPAY_INVALID_CARD_NUMBER: 'UNIONPAY_INVALID_CARD_NUMBER',
  UNIONPAY_INVALID_CUSTOMER_NAME: 'UNIONPAY_INVALID_CUSTOMER_NAME',
  UNIONPAY_INVALID_TRANSACTION_TYPE: 'UNIONPAY_INVALID_TRANSACTION_TYPE',
  UNIONPAY_BANK_ACCOUNT_NUMBER_NOT_MATCH: 'UNIONPAY_BANK_ACCOUNT_NUMBER_NOT_MATCH',
  UNIONPAY_BANK_ACCOUNT_NAME_NOT_MATCH: 'UNIONPAY_BANK_ACCOUNT_NAME_NOT_MATCH',
  UNIONPAY_AMOUNT_EXCEEDS_DAILY_LIMIT: 'UNIONPAY_AMOUNT_EXCEEDS_DAILY_LIMIT',
  UNIONPAY_AMOUNT_EXCEEDS_MONTHLY_LIMIT: 'UNIONPAY_AMOUNT_EXCEEDS_MONTHLY_LIMIT',
  UNIONPAY_BANK_ACCOUNT_AND_CODE_NOT_MATCH: 'UNIONPAY_BANK_ACCOUNT_AND_CODE_NOT_MATCH',
  UNIONPAY_BANK_ACCOUNT_AND_BRANCH_CODE_NOT_MATCH: 'UNIONPAY_BANK_ACCOUNT_AND_BRANCH_CODE_NOT_MATCH',
  UNIONPAY_BANK_ACCOUNT_NAME_NOT_MATCH_CUSTOMER_OR_ID: 'UNIONPAY_BANK_ACCOUNT_NAME_NOT_MATCH_CUSTOMER_OR_ID',
  UNIONPAY_BANK_ACCOUNT_NAME_NOT_MATCH_ID: 'UNIONPAY_BANK_ACCOUNT_NAME_NOT_MATCH_ID',
  UNIONPAY_INVALID_ID_CARD_NUMBER: 'UNIONPAY_INVALID_ID_CARD_NUMBER',
  UNIONPAY_INVALID_ID_CARD_TYPE: 'UNIONPAY_INVALID_ID_CARD_TYPE',
  UNIONPAY_ID_CARD_EXPIRED: 'UNIONPAY_ID_CARD_EXPIRED',
  UNIONPAY_ID_CARD_NAME_NOT_MATCH_CUSTOMER_NAME: 'UNIONPAY_ID_CARD_NAME_NOT_MATCH_CUSTOMER_NAME',
  UNIONPAY_ID_CARD_NUMBER_NOT_MATCH_CUSTOMER_NAME: 'UNIONPAY_ID_CARD_NUMBER_NOT_MATCH_CUSTOMER_NAME',
  UNIONPAY_CUSTOMER_NAME_NOT_MATCH_ID_CARD_NAME: 'UNIONPAY_CUSTOMER_NAME_NOT_MATCH_ID_CARD_NAME',
  UNIONPAY_INVALID_TRANSACTION_AMOUNT: 'UNIONPAY_INVALID_TRANSACTION_AMOUNT',
  UNIONPAY_INVALID_EMAIL: 'UNIONPAY_INVALID_EMAIL',
  UNIONPAY_INVALID_ADDRESS: 'UNIONPAY_INVALID_ADDRESS',
  UNIONPAY_CARD_EXPIRED: 'UNIONPAY_CARD_EXPIRED',
  UNIONPAY_CARD_INACTIVE: 'UNIONPAY_CARD_INACTIVE',
  UNIONPAY_SUSPICIOUS_TRANSACTION: 'UNIONPAY_SUSPICIOUS_TRANSACTION',
  UNIONPAY_SYSTEM_ERROR: 'UNIONPAY_SYSTEM_ERROR',
  UNIONPAY_TRANSACTION_NOT_ALLOWED: 'UNIONPAY_TRANSACTION_NOT_ALLOWED',
  UNIONPAY_EXCEEDS_WITHDRAWAL_LIMIT: 'UNIONPAY_EXCEEDS_WITHDRAWAL_LIMIT',
  UNIONPAY_EXCEEDS_WITHDRAWAL_FREQUENCY: 'UNIONPAY_EXCEEDS_WITHDRAWAL_FREQUENCY',
  UNIONPAY_SECURITY_ERROR: 'UNIONPAY_SECURITY_ERROR',
  UNIONPAY_SUSPECTED_FRAUD: 'UNIONPAY_SUSPECTED_FRAUD',
  UNIONPAY_CARD_NOT_EFFECTIVE: 'UNIONPAY_CARD_NOT_EFFECTIVE',
  UNIONPAY_SERVICE_PROVIDER_ERROR: 'UNIONPAY_SERVICE_PROVIDER_ERROR',
  UNIONPAY_UNSPECIFIED_FAILURE: 'UNIONPAY_UNSPECIFIED_FAILURE',
  UNIONPAY_TIMEOUT: 'UNIONPAY_TIMEOUT',
  UNIONPAY_SYSTEM_MALFUNCTION: 'UNIONPAY_SYSTEM_MALFUNCTION',
} as const;
